import React, { useState, useMemo } from "react";
import { FormGroup, Form, Label, Input } from "reactstrap";

export default function NeckbandCalculator() {
  const [neckHole, setNeckHole] = useState(35);
  const [sa, setSa] = useState(1.5);
  const [stretch, setStretch] = useState(20);

  const result = useMemo(() => {
    return (neckHole * (1 - stretch / 100) + 2 * sa).toFixed(2);
  }, [neckHole, sa, stretch]);

  const formatNumber = (num) => {
    let str = parseFloat(num) || 0;
    let idx = num.indexOf(".");
    if (idx > -1 && idx !== num.length - 1) {
      return parseFloat(str.toFixed(2)) || 0;
    }
    return num;
  };

  return (
    <Form>
      <div className="neckband text-center d-flex flex-wrap justify-content-around">
        <h2>Stretch neckband calculator</h2>
        <p>
          I find getting the right neckband length to be really tricky! Use this
          calculator to work out the perfect neckband length based on your
          fabric stretch. Use whichever measurement units you prefer - the
          result will be in metric, so 32.25 would be 32.25cm or 32 1/4 inches
        </p>
        <FormGroup>
          <Label>Neck hole diameter</Label>
          <Input
            type="text"
            value={neckHole}
            onChange={(e) => setNeckHole(formatNumber(e.target.value))}
          />
        </FormGroup>
        <FormGroup>
          <Label>Fabric stretch %</Label>
          <Input
            type="text"
            value={stretch}
            onChange={(e) => setStretch(formatNumber(e.target.value))}
          />
        </FormGroup>
        <FormGroup>
          <Label>Seam allowance</Label>
          <Input
            type="text"
            value={sa}
            onChange={(e) => setSa(formatNumber(e.target.value))}
          />
        </FormGroup>
      </div>
      <p class="large pt-4">
        Cut your neckband to be <strong>{result}</strong> long.
      </p>
    </Form>
  );
}
